import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { of } from 'rxjs';
import { QuestionService } from '../../service/question.service';
import { QuestionBase } from '../controls/question-base';
import { PatrolControlDetailComponent } from '../patrol-control-detail/patrol-control-detail.component';

@Component({
  selector: 'app-patrol-template-detail',
  templateUrl: './patrol-template-detail.component.html',
  styleUrls: ['./patrol-template-detail.component.less']
})
export class PatrolTemplateDetailComponent implements OnInit {
  @Input() patrolTemplate: any = null;
  questions: QuestionBase<string>[] = [];
  form!: FormGroup;
  templateform!: FormGroup;
  controlData = [
    {
      label: '输入框',
      data: {type: 'input'}
    },
    {
      label: '文本框',
      data: {type: 'textarea'}
    },
    {
      label: '数字输入框',
      data: {type: 'inputnumber'}
    },
    {
      label: '多选框',
      data: {type: 'checkbox'}
    },
    {
      label: '下拉选项',
      data: {type: 'select'}
    },
    {
      label: '日期选项',
      data: {type: 'datepicker'}
    },
    {
      label: '上传',
      data: {type: 'upload'}
    }
];

  constructor(
    public modalService: NzModalService,
    public message: NzMessageService,
    public qs: QuestionService,
    public fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.templateform = this.fb.group({
      ptName: [this.patrolTemplate === null ? null : this.patrolTemplate.ptName, [Validators.required]], // 模板名称
      typeNo: [this.patrolTemplate === null ? 1 : this.patrolTemplate.typeNo, [Validators.required]], // 模板类型
      desc: [this.patrolTemplate === null ? null : this.patrolTemplate.desc], // 模板描述
    });
    if (this.patrolTemplate !== null){
      this.patrolTemplate.controls.forEach((control: any) => {
        this.questions.push(this.qs.getControl(control.ptctNo, {
          key: control.key,
          value: control.value,
          label: control.label,
          order: control.order,
          row: control.row,
          column: control.column,
          options: control.options,
          placeholder: control.placeholder,
          unit: control.unit,
          format: control.format,
        }, 1 ));
      }
      );
      of(this.questions.sort((a, b) => a.order - b.order));
      this.form = this.qs.toFormGroup(this.questions as QuestionBase<string>[]);
    }
  }
  onDropToForm($event: any){
    const modal = this.modalService.create({
      nzTitle: '填写控件内容',
      nzContent: PatrolControlDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 400,
      nzComponentParams: {
        type: $event.dragData.type,
      },
      nzOnOk: (ev) => {
       const formData = ev.getControForm();
       if ( this.validateFormData(formData)){
        const ls = this.questions.filter((item) => {
          return item.key === formData.value.key;
        });
        if (ls.length > 0){
          this.message.warning('控件键已经存在，请重新填写！！！');
          return false;
        }else{
          // formData.value.options
          if ( formData.value.value !== null &&  formData.value.value !== '' ){
            if ($event.dragData.type === 'select'){
              const index = formData.value.options.split(',').indexOf(formData.value.value);
              if ( index < 0){
                this.message.warning('默认值未在下拉选项中！！！');
                return false;
              }
            }
          }
          let defaultValue =  formData.value.value;
          if ( $event.dragData.type === 'select' && defaultValue != null && defaultValue !== ''){
            const optionArray = formData.value.options.split(',');
            const nIndex = optionArray.indexOf(defaultValue);
            defaultValue = formData.value.key + '' + nIndex;
          }
          this.questions.push(this.qs.getControl($event.dragData.type, {
            key: formData.value.key,
            value: defaultValue,
            label: formData.value.label,
            order: formData.value.order,
            row: formData.value.row,
            column: formData.value.column,
            options: formData.value.options,
            placeholder: formData.value.placeholder,
            unit: formData.value.unit,
            format: formData.value.format,
          }, 1));
          of(this.questions.sort((a, b) => a.order - b.order));
          this.form = this.qs.toFormGroup(this.questions as QuestionBase<string>[]);
        }
        //  this.qs.getQuestions().subscribe((data) => {
        //   this.questions.push(this.qs.getControl($event.type, {}));
        //   this.form = this.qs.toFormGroup(this.questions as QuestionBase<string>[]);

        //  });
        }else{
          this.message.warning('工单数据未验证通过');

          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  public validateFormData(validateForm: any) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  delete(){
    if (this.questions != null){
      const newarr = this.questions.concat();
      // 处理新的数组变量
      newarr.pop();
      this.questions = newarr ;
      // this.form = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);
    }
  }
  deleteVote(event: any){
    if (this.questions != null){
      // const newarr = this.questions.concat();
      // 处理新的数组变量
      const index = this.questions.findIndex((item) => {
        return item.key === event;
      });
      this.questions.splice(index, 1);
      // this.questions =  newarr;
    }
  }
  editVote(event: any){
    if (this.questions != null){
      // const newarr = this.questions.concat();
      // 处理新的数组变量
      const index = this.questions.findIndex((data) => {
        return data.key === event;
      });
      if (index >= 0){
        const modal = this.modalService.create({
          nzTitle: '编辑控件内容',
          nzContent: PatrolControlDetailComponent,
          nzStyle: { top: '20px' },
          nzWidth: 400,
          nzComponentParams: {
            type: this.questions[index].ptctNo,
            control: this.questions[index]
          },
          nzOnOk: (ev) => {
           const ptctNo = this.questions[index].ptctNo;
           const  newQuestions = [...this.questions];
           newQuestions.splice(index, 1);
           const formData = ev.getControForm();
           if ( this.validateFormData(formData)){
              const ls = newQuestions.filter((item) => {
                return item.key === formData.value.key;
              });
              if (ls.length > 0){
                this.message.warning('控件键已经存在，请重新填写！！！');
                return false;
              }else{
                if (ptctNo === 'select'){
                  if ( formData.value.value !== null &&  formData.value.value !== '' ){
                    const i = formData.value.options.split(',').indexOf(formData.value.value);
                    if ( i < 0){
                      this.message.warning('默认值未在下拉选项中！！！');
                      return false;
                    }
                  }
                }
                this.questions.splice(index, 1);
                let defaultValue =  formData.value.value;
                if ( ptctNo === 'select' && defaultValue != null && defaultValue !== ''){
                  const optionArray = formData.value.options.split(',');
                  const nIndex = optionArray.indexOf(defaultValue);
                  defaultValue = formData.value.key + '' + nIndex;
                }
                this.questions.push(this.qs.getControl(ptctNo, {
                  key: formData.value.key,
                  value: defaultValue,
                  label: formData.value.label,
                  order: formData.value.order,
                  row: formData.value.row,
                  column: formData.value.column,
                  options: formData.value.options,
                  placeholder: formData.value.placeholder,
                  unit: formData.value.unit,
                  format: formData.value.format,
                }, 1)); // 2提交
                of(this.questions.sort((a, b) => a.order - b.order));
                this.form = this.qs.toFormGroup(this.questions as QuestionBase<string>[]);
              }
            }else{
              this.message.warning('工单数据未验证通过');
              return false;
            }
          },
          nzOnCancel: (ev) => {
          }
        });
      }
    }
  }

  getForm(){
    return this.form;
  }
  getTemplateForm(){
    return this.templateform;
  }
  getQuestions(){
    return this.questions;
  }
}
